/*
 * @Author: christineqiu@aijiatui.com christineqiu@aijiatui.com
 * @Date: 2024-12-27 10:01:37
 * @LastEditors: christineqiu@aijiatui.com christineqiu@aijiatui.com
 * @LastEditTime: 2025-02-10 17:03:05
 * @FilePath: /management-portal/src/router/modules/company.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteRecordRaw } from 'vue-router';

export default {
  path: '/company',
  name: 'company',
  redirect: '/company/staff/index',
  component: () => import('@/layout/index.vue'),
  meta: {
    title: 'menus.company',
    icon: 'el-icon-officeBuilding',
    sort: 6
  },
  children: [
    {
      path: '/company/staff/index',
      name: 'company_staff',
      component: () => import('@/views/company/staff/index.vue'),
      meta: {
        title: 'menus.company_staff',
        icon: 'el-icon-user'
      }
    },
    {
      path: '/company/staff/add',
      name: 'company_staff_add',
      component: () => import('@/views/company/staff/add.vue'),
      meta: {
        title: 'menus.companyStaffAdd',
        isMenu: false
      }
    },
    {
      path: '/company/staff/detail',
      name: 'company_staff_detail',
      component: () => import('@/views/company/staff/detail.vue'),
      meta: {
        title: 'menus.companyStaffDetail',
        isMenu: false
      }
    },
    {
      path: '/company/role/index',
      name: 'company_role',
      component: () => import('@/views/company/role/index.vue'),
      meta: {
        title: 'menus.company_role',
        icon: 'el-icon-ElementPlus'
      }
    },
    {
      path: '/company/menu/index',
      name: 'company_menu',
      component: () => import('@/views/company/menu/index.vue'),
      meta: {
        title: 'menus.company_menu',
        icon: 'el-icon-More'
      }
    },
    {
      path: '/company/work/handover',
      name: 'company_workHandover',
      component: () => import('@/views/company/workHandover/index.vue'),
      meta: {
        title: 'menus.company_workHandover',
        icon: 'el-icon-Switch'
      }
    },
    {
      path: '/company/company/index',
      name: 'company_company',
      component: () => import('@/views/company/company/index.vue'),
      meta: {
        title: 'menus.company_company',
        icon: 'el-icon-Notebook'
      }
    },
    {
      path: '/company/ai-assistant/index',
      name: 'ai-assistant',
      component: () => import('@/views/company/ai-assistant/tabs.vue'),
      meta: {
        title: 'menus.aiAssistant',
        icon: 'el-icon-Notebook'
      }
    }
  ]
} as RouteRecordRaw;
